angular.module( 'angus.directives' ).directive( 'acctGainLossBySrc', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				closeCb: "=",
				model: "=actionModel",
				settings: "=acctGainLossBySrcSettings"
			},
			templateUrl: actionViewTemplates.acctGainBySrcContainer
		};
	}
] ).directive('updateColorFromLabel', [ '$',
	function($){
		return {
			scope: {
				propertyValue: "=",
			},
			link: function(scope, element){

				// scope.$watch(function() {
				// 		return scope.ngModel;
				// 	}, function(newVal) {
				// 		if (newVal)
				// 			plot(newVal);
				// 	});

				var colorValue = $('.sideNavContainer .legendLabel:contains(" ' + scope.propertyValue + '")').css('color');

				element.css('color', colorValue);
			}
		};
	}
]);